import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Formik, FieldArray, Form as FormikForm, ErrorMessage } from 'formik';
import * as yup from 'yup';
import Select, { components } from 'react-select';
import { useSelector } from 'react-redux';
// import AssessmentApis from './assessmentApis';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import {
  useGetAllAssessmentMutation,
  usePostEditAssessmentMutation,
  usePostAssessmentMutation,
  useGetSeriesDataMutation,
  useGetApiDataMutation,
} from 'slices/get/assessment';
import useService from 'views/default/useService';
import { useLocation } from 'react-router-dom';
import _, { values } from 'lodash';
import { useGetAllCommonAdminInitialDataMutation, usePostCommonMutation } from 'slices/get/common';
import { usePostSchoolMutation } from 'slices/get/school';

const validationSchema = yup.object().shape({
  series_list: yup.array().min(1, 'Select at least one series'),
  standard_list: yup.array().max(1, 'Select at least one standard'),
  subject_list: yup.array().max(1, 'Select at least one subject'),
  lesson_list: yup.string().required('Lesson is required'),
  part_list: yup.array().of(
    yup.object().shape({
      part: yup.string().required('Part name is required'),
    })
  ),
  active: yup.string().required('Status is required'),
  excelFile: yup.mixed().required('Excel file is required'),
});

const Control = ({ children, label, ...props }) => {
  return (
    <components.Control {...props} className="form-floating">
      {children}
      <label>{label}</label>
    </components.Control>
  );
};

const ModelEditDayPlan = ({ tableInstance }) => {
  const [getAllAssessment] = useGetAllAssessmentMutation();
  const [getSeriesData] = useGetSeriesDataMutation();
  const [getAllCommonAdminInitialData] = useGetAllCommonAdminInitialDataMutation();
  const [postAssessment] = usePostAssessmentMutation();
  const [postCommon] = usePostCommonMutation();
  const [postEditAssessment] = usePostEditAssessmentMutation();
  const { checkAccessTime, fetchAccessToken } = useService();
  const location = useLocation();
  const currentPath = location.pathname;
  let { isOpen, onCloseEmptyModal, whichModal, onCloseAddModal, selectedFlatRows } = tableInstance;

  const queryParams = new URLSearchParams(location.search);
  const subjectId = queryParams.get('subjectId');

  const [data, setData] = useState();
  const [seriesData, setSeriesdata] = useState([]);
  const [standardData, setStandardData] = useState([]);
  const [subjectData, setSubjectsdata] = useState([]);
  const [lessonData, setLessonData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [dayPlanData, setDayPlanData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [lessonTitle, setLessonTitle] = useState("");
  const [lessonType, setLessonType] = useState("");
  const [homework, setHomework] = useState([]);

  // setDayPlanData({ series: selectedOptions });
  const [requiredFields, setRequiredFields] = useState({
    seriesRequired: false,
    standardsRequired: false,
    subjectsRequired: false,
    lessonsRequired: false,
    schoolRequired: false,
    sectionRequired:false,
    statusRequired: false,
    dayRequired : false,
    planRequired: false,
  });
const [titleImageSets, setTitleImageSets] = useState([]);
  const [titleVideoSets, setTitleVideoSets] = useState([]);

  // Initial data (pretend this comes from API)
  // const response = {
  //   lessonTitle: 'this is the sample title',
  // lessonType: 'I Do',
  // homework : "please complete all this by the end of this data",

  //   titleAndImagesData: [
  //     {
  //       title: 'Nature Collection',
  //       image1: 'https://picsum.photos/id/1018/200/150',
  //       image2: 'https://picsum.photos/id/1025/200/150',
  //       image3: 'https://picsum.photos/id/1035/200/150',
  //     },
  //     {
  //       title: 'Urban Scenes',
  //       image1: 'https://picsum.photos/id/1043/200/150',
  //       image2: 'https://picsum.photos/id/1050/200/150',
  //       image3: 'https://picsum.photos/id/1062/200/150',
  //       image4: 'https://picsum.photos/id/1076/200/150',
  //       image5: 'https://picsum.photos/id/1084/200/150',
  //     },
  //   ],
  //   titleAndUrlsData: [
  //     {
  //       title: 'Tutorial Series',
  //       url1: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
  //       url2: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
  //       url3: 'https://www.youtube.com/watch?v=lTTajzrSkCw',
  //     },
  //     {
  //       title: 'Music Videos',
  //       url1: 'https://www.youtube.com/watch?v=Zi_XLOBDo_Y',
  //       url2: 'https://www.youtube.com/watch?v=kXYiU_JCYtU',
  //       url3: 'https://www.youtube.com/watch?v=2vjPBrBU-TM',
  //       url4: 'https://www.youtube.com/watch?v=09R8_2nJtjg',
  //       url5: 'https://www.youtube.com/watch?v=fLexgOxsZu0',
  //     },
  //   ],
  // };

  // useEffect(() => {
  //   const transformImageData = (data) =>
  //     data.map((item) => ({
  //       title: item.title,
  //       images: Object.keys(item)
  //         .filter((key) => key.startsWith('image'))
  //         .map((key) => ({
  //           name: item[key],
  //           existing: true,
  //         })),
  //     }));

  //   const transformVideoData = (data) =>
  //     data.map((item) => ({
  //       title: item.title,
  //       videos: Object.keys(item)
  //         .filter((key) => key.startsWith('url'))
  //         .map((key) => item[key]),
  //     }));

  //   setTitleImageSets(transformImageData(selectedFlatRows[0]?.original.titleAndImagesData));
  //   setTitleVideoSets(transformVideoData(selectedFlatRows[0]?.original.titleAndUrlsData));
  // }, []);
useEffect(() => {
  const transformImageData = (data) =>
    (data || []).map((item) => ({
      title: item?.title || '',
      images: Object.keys(item || {})
        .filter((key) => key?.startsWith?.('image'))
        .map((key) => ({
          name: item[key],
          existing: true,
        })),
    }));

  const transformVideoData = (data) =>
    (data || []).map((item) => ({
      title: item?.title || '',
      videos: Object.keys(item || {})
        .filter((key) => key?.startsWith?.('url'))
        .map((key) => item[key]),
    }));

  const selected = selectedFlatRows[0]?.original;

  setTitleImageSets(transformImageData(selected?.titleAndImagesData));
  setTitleVideoSets(transformVideoData(selected?.titleAndUrlsData));
}, []);

  const removeImage = (setIndex, imgIndex) => {
    const updated = [...titleImageSets];
    updated[setIndex].images.splice(imgIndex, 1);
    setTitleImageSets(updated);
  };

  const addTitleImageSet = () => {
    setTitleImageSets([...titleImageSets, { title: '', images: [] }]);
  };

  const removeTitleImageSet = (index) => {
    const updated = [...titleImageSets];
    updated.splice(index, 1);
    setTitleImageSets(updated);
  };

  const addTitleVideoSet = () => {
    setTitleVideoSets([...titleVideoSets, { title: '', videos: [''] }]);
  };

  const removeTitleVideoSet = (index) => {
    const updated = [...titleVideoSets];
    updated.splice(index, 1);
    setTitleVideoSets(updated);
  };

  const handleVideoChange = (setIndex, videoIndex, value) => {
    const updated = [...titleVideoSets];
    updated[setIndex].videos[videoIndex] = value;
    setTitleVideoSets(updated);
  };

  const addVideoUrlField = (setIndex) => {
    const updated = [...titleVideoSets];
    updated[setIndex].videos.push('');
    setTitleVideoSets(updated);
  };

  const removeVideoUrlField = (setIndex, videoIndex) => {
    const updated = [...titleVideoSets];
    updated[setIndex].videos.splice(videoIndex, 1);
    setTitleVideoSets(updated);
  };
  let assessmentQuetionsData = {
    assessmentId: 10,
    questionAndOptions: [
      { question: '', options: '', answer: '' },
      { question: '', options: '', answer: '' },
    ],
  };
  const access_token = fetchAccessToken();
  const [successMessage, setSuccessMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [postSchool] = usePostSchoolMutation();
  

  useEffect(() => {
    if (selectedFlatRows.length > 0) {
      let selectedData = selectedFlatRows[0]?.original;
      dayPlanData.series = { value: selectedData.series_id, label: selectedData.series_name };
      dayPlanData.school = { value: selectedData.school_id, label: selectedData.school_name };
      dayPlanData.subjects = { value: selectedData.subject_id, label: selectedData.subject_name };
      dayPlanData.standard = {
        value: selectedData.standard_id,
        label: selectedData.standard_name,
      };
      dayPlanData.section = {
        value: selectedData.section_id,
        label: selectedData.section_name,
      };
      dayPlanData.lessons = { value: selectedData.lesson_id, label: selectedData.lesson_name };
      dayPlanData.plan = selectedData.plan;
      dayPlanData.day = selectedData.day;
      dayPlanData.active = selectedData.active;
      dayPlanData.lessonType = [{ value: "I Do", label: "I Do" },{ value: "You Do", label: "You Do" },{ value: "We Do", label: "We Do" }].find(each => each.value == selectedData.lessonType)
      dayPlanData.lessonTitle = selectedData.lessonTitle
      dayPlanData.homework  = selectedData.homework
      // dayPlanData.lessonTitle = selectedData.lessonTitle
      // dayPlanData.lessonType= selectedData.lessonType,
      // dayPlanData.homework = selectedData.homework

    dayPlanData.titleAndImagesData = selectedData.titleAndImagesData
    dayPlanData.titleAndUrlsData = selectedData.titleAndUrlsData
    setLessonTitle( selectedData.lessonTitle)
    setLessonType( dayPlanData.lessonType)
    setHomework(selectedData.homework)
      getSeriesData({
        ep: `/lesson/get_lessons?standard_id=${selectedData.standard_id}&subject_id=${selectedData.subject_id}&series_ids=${selectedData.series_id}`,
        token: access_token,
      }).then((response) => {
        if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
          let lessonOptions = response.data.data.map((each) => {
            if (each.active == 'on') {
              return { value: each.id, label: each.lesson };
            }
          });
          checkAccessTime(response, currentPath);
          setLessonData(lessonOptions);
        }
      });
    }

    getAllCommonAdminInitialData({ ep: '/standard/data', token: access_token }).then((response) => {
      if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
        let standarOptions = response.data.data.map((each) => {
          if (each.active == 'on') {
            return { value: each.id, label: each.name };
          }
        });
        checkAccessTime(response, currentPath);
        setStandardData(standarOptions);
      }
    });
    getAllCommonAdminInitialData({ ep: '/series/data', token: access_token }).then((response) => {
      if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
        checkAccessTime(response, currentPath);
        let seriesOption = response.data.data.map((each) => ({ value: each.id, label: each.name }));
        setSeriesdata(seriesOption);
      }
    });
    getAllCommonAdminInitialData({ ep: '/subject/data', token: access_token }).then((response) => {
      checkAccessTime(response, currentPath);
      if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
        let subjectsOption = response.data.data.map((each) => ({
          value: each.id,
          label: each.name,
        }));
        setSubjectsdata(subjectsOption);
      }
    });
    getAllCommonAdminInitialData({ ep: '/school/schools_list', token: access_token }).then(
      (response) => {
        if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
          let schoolOptions = response.data.data.map((each) => ({
            value: each.id,
            label: each.name,
          }));
          setSchoolData(schoolOptions);

          checkAccessTime(response, currentPath);
        }
      }
    );
    getAllCommonAdminInitialData({ ep: '/section/section_list', token: access_token }).then(
      (response) => {
        if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
          let standarOptions = response.data.data.map((each) => {
            return { value: each.id, label: each.name };
          });
          checkAccessTime(response, currentPath);
          setSectionData(standarOptions);
        }
      }
    );
  }, []); // The empty dependency array means the effect runs once after the initial render



  const checkFields = (dayPlanData) => {
    const newRequiredFields = _.cloneDeep(requiredFields);
    // if (dayPlanData.length == 0) {
    //   newRequiredFields.seriesRequired = true;
    // }

    if (dayPlanData.series == undefined || dayPlanData.series.length == 0) {
      newRequiredFields.seriesRequired = true;
    }
    if (dayPlanData.standard == undefined || dayPlanData.standard.length == 0) {
      newRequiredFields.standardsRequired = true;
    }
    if (dayPlanData.subjects == undefined || dayPlanData.subjects.length == 0) {
      newRequiredFields.subjectsRequired = true;
    }
    if (dayPlanData.lessons == undefined || dayPlanData.lessons.length == 0) {
      newRequiredFields.lessonsRequired = true;
    }
    
    // if (dayPlanData.plan == undefined || dayPlanData.plan.length == 0) {
    //   newRequiredFields.planRequired = true;
    // }
    if (dayPlanData.day == undefined || dayPlanData.day.length == 0) {
      newRequiredFields.dayRequired = true;
    }
    if (dayPlanData.school == undefined || dayPlanData.school.length == 0) {
      newRequiredFields.schoolRequired = true;
    }
    if (dayPlanData.section == undefined || dayPlanData.section.length == 0) {
      newRequiredFields.sectionRequired = true;
    }

    if (!dayPlanData.active || dayPlanData.active == undefined) {
      newRequiredFields.statusRequired = true;
    }

    setRequiredFields(newRequiredFields);
    if (
      !newRequiredFields.seriesRequired &&
      !newRequiredFields.standardsRequired &&
      !newRequiredFields.subjectsRequired &&
      !newRequiredFields.schoolRequired &&
      !newRequiredFields.lessonsRequired &&
      !newRequiredFields.statusRequired &&
      !newRequiredFields.sectionRequired &&
      !newRequiredFields.dayRequired 
      // &&
      // !newRequiredFields.planRequired
    ) {
      return {
        status: true,
      };
    } else {
      return {
        status: false,
      };
    }
  };


  const handleHomeworkChange = (e) => {
    setHomework(e.target.value); // Update the homework state
  };
const newHandleSubmit = async () => {
  const allFieldsValid = (await checkFields(dayPlanData)).status;
  if (!allFieldsValid) return;

  const originalData = selectedFlatRows[0]?.original;

  const changedFields = {};

  // Primitive fields
  const simpleFields = {
    lesson_type: lessonType?.value,
    lesson_title: lessonTitle,
    homework: homework,
    series_id: dayPlanData.series?.value,
    school_id: dayPlanData.school?.value,
    standard_id: dayPlanData.standard?.value,
    subject_id: subjectId,
    lesson_id: dayPlanData.lessons?.value,
    section_id: dayPlanData.section?.value,
    active: dayPlanData.active,
     day: dayPlanData.day,
        // plan: dayPlanData.plan,
  };

  for (const [key, value] of Object.entries(simpleFields)) {
    if (value !== originalData[key]) {
      changedFields[key] = value;
    }
  }

  // Complex fields – teachers/dayPlans
  const originalDayPlans = originalData.dayPlans || [];
  

  // Media fields – compare by filename or length
  if (
    titleImageSets.length !== (originalData.titleImageSets?.length || 0) ||
    titleImageSets.some((set, i) =>
      set.title !== originalData.titleImageSets?.[i]?.title ||
      set.images.length !== originalData.titleImageSets?.[i]?.images?.length
    )
  ) {
    changedFields.titleImageSets = titleImageSets;
  }

  if (
    titleVideoSets.length !== (originalData.titleVideoSets?.length || 0) ||
    titleVideoSets.some((set, i) =>
      set.title !== originalData.titleVideoSets?.[i]?.title ||
      JSON.stringify(set.videos) !== JSON.stringify(originalData.titleVideoSets?.[i]?.videos)
    )
  ) {
    changedFields.titleVideoSets = titleVideoSets;
  }

  // Build FormData only for changed fields
  const formData = new FormData();
  formData.append('id', originalData.id); // always needed to identify the record

Object.entries(changedFields).forEach(([key, value]) => {
  if (value == null) return;

  if (Array.isArray(value)) {
    if (key === 'titleImageSets') {
      value.forEach((set, i) => {
        formData.append(`titleImageSets[${i}].title`, set.title);

        // Send only new (non-existing) images in binary format with correct position
        set.images.forEach((img, j) => {
          if (!img.existing && img.file) {
            formData.append(`titleImageSets[${i}][${j}].images`, img.file);
          }
        });

        // Optional: send image count
        formData.append(`titleImageSets[${i}].imagesLength`, set.images.length);
      });

      formData.append('titleImageSetsLength', value.length);
    } else {
      formData.append(key, JSON.stringify(value));
    }
  } else {
    formData.append(key, String(value));
  }
});


  // Submit only changed fields
  postSchool({
    ep: '/school/day_plans_update',
    formData,
    token: access_token,
  }).then((response) => {
    if (response?.data?.status) {
      setSuccessMessage(response.data);
      setIsSuccess(true);
      setTimeout(() => window.location.reload(), 2000);
    } else {
      setSuccessMessage(response.data || 'Submission failed');
      setIsSuccess(true);
    }
  });
};


  return (
    <>
      {
        <Formik
          //   initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            
          }}
        >
          {({ handleSubmit, errors, touched, setFieldValue, handleBlur, values }) => (
            <FormikForm onSubmit={newHandleSubmit}>
              <Modal
                backdrop="static"
                keyboard={false}
                className="modal-right fade"
                show={isOpen}
                onHide={onCloseEmptyModal}
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {whichModal.slice(0, 1).toUpperCase()}
                    {whichModal.slice(1)} Day Plan
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div className="mb-3 position-relative tooltip-end-top">
                          <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={[{ value: "I Do", label: "I Do" },{ value: "You Do", label: "You Do" },{ value: "We Do", label: "We Do" }]}
                      onChange={(selectedOptions) => {
                        requiredFields.lessonTypeRequird = false;
                        setLessonType(selectedOptions);
                      }}
                      value={lessonType}
                      placeholder="Select Lesson Type"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                    <input
                      type="text"
                      className={`form-control ${requiredFields.lessonTitleRequired ? 'is-invalid' : ''}`} 
                      placeholder="Enter Lesson Title"
                      value={lessonTitle || ''}  // Ensure it is controlled
                      onChange={(e) => {
                        requiredFields.lessonTitleRequired = false;
                        setLessonTitle( e.target.value);
                        setRequiredFields(requiredFields);
                      }}
                    />
                    {requiredFields.lessonTitleRequired && (
                      <div className="d-block invalid-tooltip">Please enter a lesson title</div>
                    )}
                  </div>
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={seriesData}
                      onChange={(selectedOptions) => {
                        requiredFields.seriesRequired = false;

                        setDayPlanData((prevData) => {
                          const updatedData = {
                            ...prevData,
                            series: selectedOptions, // Update 'series' in state
                          };

                          // Check if standard and subjects are defined
                          if (
                            updatedData.standard !== undefined &&
                            updatedData.subjects !== undefined
                          ) {
                            getSeriesData({
                              ep: `/lesson/get_lessons?standard_id=${updatedData.standard.value}&subject_id=${updatedData.subjects.value}&series_ids=${updatedData.series.value}`,
                              token: access_token,
                            }).then((response) => {
                              if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
                                let lessonOptions = response.data.data.map((each) => {
                                  if (each.active == 'on') {
                                    return { value: each.id, label: each.lesson };
                                  }
                                });
                                checkAccessTime(response, currentPath);
                                setLessonData(lessonOptions);
                              }
                            });
                          }

                          return updatedData;
                        });

                        // Optionally update required fields state
                        setRequiredFields({ ...requiredFields });
                      }}
                      value={dayPlanData.series}
                      placeholder="Select Series"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />

                    {requiredFields.seriesRequired && (
                      <div className="d-block invalid-tooltip">
                        Please select at least one series
                      </div>
                    )}
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={schoolData}
                      onChange={(selectedOptions) => {
                        requiredFields.schoolRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          school: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.school}
                      placeholder="Select School"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.schoolRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select school</div>
                    )}
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={standardData}
                      onChange={(selectedOptions) => {
                        setDayPlanData((prevData) => {
                          const updatedData = {
                            ...prevData,
                            standard: selectedOptions, // Update 'series' in state
                          };

                          // Check if standard and subjects are defined
                          if (
                            updatedData.series != undefined &&
                            updatedData.series != undefined &&
                            updatedData.subjects != undefined
                          ) {
                            getSeriesData({
                              ep: '/lesson/get_lessons?standard_id=8&subject_id=2&series_ids=1',
                              token: access_token,
                            }).then((response) => {
                              if(response && response?.data && response?.data?.data && response.data.data.length > 0) {
                                let lessonOptions = response.data.data.map((each) => {
                                  if (each.active == 'on') {
                                    return { value: each.id, label: each.lesson };
                                  }
                                });
                                checkAccessTime(response, currentPath);
                                setLessonData(lessonOptions);
                              }
                            });
                          }

                          return updatedData;
                        });

                        requiredFields.standardsRequired = false;

                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.standard}
                      placeholder="Select Standard"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.standardsRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select standard</div>
                    )}
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={sectionData}
                      onChange={(selectedOptions) => {
                        requiredFields.sectionRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          section: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.section}
                      placeholder="Select School"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.sectionRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select section</div>
                    )}
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={subjectData}
                      isDisabled={true}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          backgroundColor: state.isDisabled ? '#f0f0f0' : base.backgroundColor,
                          borderColor: state.isDisabled ? '#d3d3d3' : base.borderColor,
                          cursor: state.isDisabled ? 'not-allowed' : base.cursor,
                          opacity: state.isDisabled ? 0.8 : 1,
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: '#999',
                        }),
                        singleValue: (base, state) => ({
                          ...base,
                          color: state.isDisabled ? '#999' : base.color,
                        }),
                      }}
                      onChange={(selectedOptions) => {
                        setDayPlanData((prevData) => ({
                          ...prevData,
                          subjects: selectedOptions,
                        }));

                        requiredFields.subjectsRequired = false;
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.subjects}
                      placeholder="Select Subject"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.subjectsRequired && (
                      <div className="d-block invalid-tooltip">Please select subject</div>
                    )}
                  </div>

                  <div className="mb-3 position-relative tooltip-end-top">
                    <Select
                      cacheOptions={false}
                      classNamePrefix="react-select"
                      options={lessonData}
                      onChange={(selectedOptions) => {
                        // console.log("selectedOptions....",selectedOptions);
                        // setFieldValue('series_list', selectedOptions);
                        // requiredFields.seriesRequired = false
                        requiredFields.lessonsRequired = false;
                        // setDayPlanData({'standard' : selectedOptions})
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          lessons: selectedOptions, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                      value={dayPlanData.lessons}
                      placeholder="Select Lesson"
                      components={{ Control: (props) => <Control {...props} /> }}
                    />
                    {requiredFields.lessonsRequired == true && (
                      <div className="d-block invalid-tooltip">Plese select lesson</div>
                    )}
                  </div>
                  <div className="mb-3 position-relative tooltip-end-top">
                          <input
                            type="text"
                            className={`form-control ${
                              requiredFields.dayRequired ? 'is-invalid' : ''
                            }`}
                            placeholder="Enter Day"
                            value={dayPlanData.day || ''}
                            onChange={(e) => {
                              requiredFields.lessonsRequired = false;
                              setDayPlanData((prevData) => ({
                                ...prevData, // Spread the existing state
                                day: e.target.value, // Add/update key-value pair for 'date'
                              }));

                              requiredFields.dayRequired = !e.target.value;
                              setRequiredFields(requiredFields);
                            }}
                          />
                          {requiredFields.dayRequired && (
                            <div className="d-block invalid-tooltip">Please enter day</div>
                          )}
                        </div>
                  {/* <div className="mb-3 position-relative tooltip-end-top">
                    <textarea
                      style={{ height: '100px' }}
                      className="form-control"
                      name="plan"
                      placeholder="Enter plan details here"
                      value={dayPlanData.plan || ''}
                      onChange={(event) => {
                        const planValue = event.target.value;
                        setDayPlanData((prevData) => ({
                          ...prevData,
                          plan: planValue,
                        }));

                        requiredFields.planRequired = false;
                        setRequiredFields({ ...requiredFields });
                      }}
                    />
                    {requiredFields.planRequired && (
                      <div className="d-block invalid-tooltip">Please enter plan</div>
                    )}
                  </div> */}
                   <div className="container mt-4">
      <h4>Image Sets</h4>
      {titleImageSets.map((set, index) => (
        <div key={index} className="border p-3 mb-3 rounded bg-light">
          {/* Title Input */}
          <textarea
            type="text"
            rows="4"
            className="form-control mb-2"
            placeholder="Enter Title"
            value={set.title}
            onChange={(e) => {
              const updated = [...titleImageSets];
              updated[index].title = e.target.value;
              setTitleImageSets(updated);
            }}
          />

          <ul className="mb-0">
            {set.images.map((img, imgIndex) => (
              <li key={imgIndex} className="mb-2">
                {img.existing && typeof img.name === 'string' && img.name.startsWith('http') ? (
                  <>
                    <img src={img.name} alt="Uploaded" width="150" className="d-block mb-2" />
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) {
                          const updated = [...titleImageSets];
                          updated[index].images[imgIndex] = {
                            name: file.name,
                            file,
                            existing: false,
                          };
                          setTitleImageSets(updated);
                        }
                      }}
                    />
                    <Button
                      variant="danger"
                      size="sm"
                      className="ml-2 mt-1"
                      onClick={() => removeImage(index, imgIndex)}
                    >
                      Remove
                    </Button>
                  </>
                ) : (
                  <>
                    {img.name}
                    <Button
                      variant="danger"
                      size="sm"
                      className="ml-2"
                      onClick={() => removeImage(index, imgIndex)}
                    >
                      Remove
                    </Button>
                  </>
                )}
              </li>
            ))}
          </ul>

          <input
            type="file"
            accept="image/*"
            multiple
            className="form-control mt-2"
            onChange={(e) => {
              const files = Array.from(e.target.files).slice(0, 10);
              const newFiles = files.map((file) => ({
                name: file.name,
                file,
                existing: false,
              }));
              const updated = [...titleImageSets];
              updated[index].images = updated[index].images.concat(newFiles);
              setTitleImageSets(updated);
            }}
          />

          <Button
            variant="danger"
            className="mt-3"
            onClick={() => removeTitleImageSet(index)}
            disabled={titleImageSets.length === 1}
          >
            Remove Title & Images
          </Button>
        </div>
      ))}

      <Button variant="primary" onClick={addTitleImageSet} className="mb-4">
        Add Title & Images
      </Button>

      <h4>Video Sets</h4>
      {titleVideoSets.map((set, index) => (
        <div key={index} className="border p-3 mb-3 rounded bg-light">
          {/* Title Input */}
          <textarea
            type="text"
            rows="4"
            className="form-control mb-2"
            placeholder="Enter Title"
            value={set.title}
            onChange={(e) => {
              const updated = [...titleVideoSets];
              updated[index].title = e.target.value;
              setTitleVideoSets(updated);
            }}
          />

          {set.videos.map((url, videoIndex) => (
            <div key={videoIndex} className="d-flex mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Video URL"
                value={url}
                onChange={(e) => handleVideoChange(index, videoIndex, e.target.value)}
              />
              <Button
                variant="danger"
                size="sm"
                className="ml-2"
                onClick={() => removeVideoUrlField(index, videoIndex)}
                disabled={set.videos.length === 1}
              >
                -
              </Button>
            </div>
          ))}

          <Button
            variant="primary"
            size="sm"
            className="mr-2"
            onClick={() => addVideoUrlField(index)}
          >
            +
          </Button>
          <Button
            variant="danger"
            className="mt-2"
            onClick={() => removeTitleVideoSet(index)}
            disabled={titleVideoSets.length === 1}
          >
            Remove Title & Videos
          </Button>
        </div>
      ))}

      <Button variant="primary" onClick={addTitleVideoSet}>
        Add Title & Videos
      </Button>
    </div>
    <textarea
        className="form-control"
        rows="4"
        placeholder="Enter Homework"
        value={dayPlanData.homework}
        onChange={handleHomeworkChange}
      />
                  <div className="mb-3 filled tooltip-end-top">
                    <Form.Label>Status</Form.Label>
                    <Form.Check
                      type="radio"
                      label="On"
                      value="on"
                      id="statusRadio1"
                      name="active"
                      checked={dayPlanData.active === 'on'}
                      onChange={(event) => {
                        // setFieldValue('active', event.target.value);
                        requiredFields.statusRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          active: event.target.value, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                    />
                    <Form.Check
                      type="radio"
                      label="Off"
                      value="off"
                      id="statusRadio2"
                      name="active"
                      checked={dayPlanData.active === 'off'}
                      onChange={(event) => {
                        // setFieldValue('active', event.target.value);
                        requiredFields.statusRequired = false;
                        setDayPlanData((prevData) => ({
                          ...prevData, // Spread the existing state
                          active: event.target.value, // Add/update key-value pair for 'date'
                        }));
                        setRequiredFields(requiredFields);
                      }}
                    />
                    {requiredFields.statusRequired == true && (
                      <div className="d-block invalid-tooltip">Please select status</div>
                    )}
                  </div>
                </Modal.Body>

                {isSuccess && (
                  <div
                    className={`card mb-3 ${
                      successMessage.status ? 'bg-success' : 'bg-danger'
                    } text-white`} // Dynamically set the background color based on success or failure
                    style={{ marginTop: '5px' }}
                  >
                    <div className="card-body">
                      <p className="card-text">{successMessage.message}</p>
                    </div>
                  </div>
                )}
                <Modal.Footer>
                  <Button variant="outline-primary" onClick={onCloseEmptyModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" onClick={newHandleSubmit}>
                    Add
                  </Button>
                </Modal.Footer>
              </Modal>
            </FormikForm>
          )}
        </Formik>
      }
    </>
  );
};

export default ModelEditDayPlan;
